export default {
    setLoading: function(state, params){
        state.loading = params;
    },

    setUserInfo: function(state, payload){
        state.userId = localStorage.getItem("userId");
        state.userPicture = payload.userPicture;
        state.userIdentityNumber = payload.userIdentityNumber;
        state.userNickName = payload.userNickName;
        state.vipInfo = payload.vipInfo;
    },
}